import React from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

const SuccessfulOnboarded = () => {
  const onbordeddata = useSelector((state) => state.onboarding?.onbordeddata);

  // API returns { id, name, country, tenant_id } - use 'id' as entity ID
  const entity_id = onbordeddata?.id;

  const navigate = useNavigate();
  const handleViewEntity = () => {
    navigate(`/entity/${entity_id}/dashboard`);
  };

  const closeWizard = () => {
    navigate("/entities");
  };
  return (
    <div>
      <div className="formgrid grid flex justify-content-center align-item-center">
        <div className="no-key-container">
          <div>
            <svg
              width="136"
              height="136"
              viewBox="0 0 136 136"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g filter="url(#filter0_d_5520_64381)">
                <rect
                  x="12"
                  y="10"
                  width="112"
                  height="112"
                  rx="40"
                  fill="white"
                  shapeRendering="crispEdges"
                />
                <path
                  d="M36.5 38.875C36.125 38.375 36 37.75 36 37.125C36 35.375 37.375 34 39 34H52.625C54.125 34 55.375 34.75 56.125 36L64.625 50.25C58.625 51 53.25 53.875 49.25 58L36.5 38.875ZM99.375 38.875L86.625 58C82.625 53.875 77.25 51 71.25 50.25L79.75 36C80.5 34.75 81.75 34 83.25 34H96.875C98.625 34 100 35.375 100 37.125C100 37.75 99.75 38.375 99.375 38.875ZM46 76C46 68.25 50.125 61 57 57C63.75 53.125 72.125 53.125 79 57C85.75 61 90 68.25 90 76C90 83.875 85.75 91.125 79 95.125C72.125 99 63.75 99 57 95.125C50.125 91.125 46 83.875 46 76ZM69 64.25C68.625 63.375 67.375 63.375 66.875 64.25L64.125 69.875C63.875 70.25 63.625 70.5 63.25 70.5L57 71.375C56 71.5 55.625 72.75 56.25 73.375L60.875 77.875C61.125 78.125 61.25 78.5 61.125 78.875L60.125 85.125C59.875 86.125 60.875 86.75 61.75 86.375L67.375 83.375C67.75 83.25 68.125 83.25 68.5 83.375L74.125 86.375C75 86.75 76 86.125 75.75 85.125L74.75 78.875C74.625 78.5 74.75 78.125 75 77.875L79.625 73.375C80.25 72.75 79.875 71.625 78.875 71.375L72.625 70.5C72.25 70.5 72 70.25 71.75 69.875L69 64.25Z"
                  fill="#188A42"
                />
                <path
                  opacity="0.4"
                  d="M36.5 38.875C36.125 38.375 36 37.75 36 37.125C36 35.375 37.375 34 39 34H52.625C54.125 34 55.375 34.75 56.125 36L64.625 50.25C58.625 51 53.25 53.875 49.25 58L36.5 38.875ZM99.375 38.875L86.625 58C82.625 53.875 77.25 51 71.25 50.25L79.75 36C80.5 34.75 81.75 34 83.25 34H96.875C98.625 34 100 35.375 100 37.125C100 37.75 99.75 38.375 99.375 38.875ZM46 76C46 68.25 50.125 61 57 57C63.75 53.125 72.125 53.125 79 57C85.75 61 90 68.25 90 76C90 83.875 85.75 91.125 79 95.125C72.125 99 63.75 99 57 95.125C50.125 91.125 46 83.875 46 76ZM69 64.25C68.625 63.375 67.375 63.375 66.875 64.25L64.125 69.875C63.875 70.25 63.625 70.5 63.25 70.5L57 71.375C56 71.5 55.625 72.75 56.25 73.375L60.875 77.875C61.125 78.125 61.25 78.5 61.125 78.875L60.125 85.125C59.875 86.125 60.875 86.75 61.75 86.375L67.375 83.375C67.75 83.25 68.125 83.25 68.5 83.375L74.125 86.375C75 86.75 76 86.125 75.75 85.125L74.75 78.875C74.625 78.5 74.75 78.125 75 77.875L79.625 73.375C80.25 72.75 79.875 71.625 78.875 71.375L72.625 70.5C72.25 70.5 72 70.25 71.75 69.875L69 64.25Z"
                  fill="#188A42"
                />
              </g>
              <defs>
                <filter
                  id="filter0_d_5520_64381"
                  x="0"
                  y="0"
                  width="136"
                  height="136"
                  filterUnits="userSpaceOnUse"
                  colorInterpolationFilters="sRGB"
                >
                  <feFlood floodOpacity="0" result="BackgroundImageFix" />
                  <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                  />
                  <feOffset dy="2" />
                  <feGaussianBlur stdDeviation="6" />
                  <feComposite in2="hardAlpha" operator="out" />
                  <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
                  />
                  <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_5520_64381"
                  />
                  <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow_5520_64381"
                    result="shape"
                  />
                </filter>
              </defs>
            </svg>
          </div>
          <div className="no-key-align">
            <p className="no-key-personnel mb-2">
              Congrats, entity has been onboarded
            </p>
            <p className="no-key-personnel-para">
              Your new entity has been created.
            </p>
          </div>
          <button className="add-new-contact" onClick={handleViewEntity}>
            {" "}
            View Entity Profile
          </button>
          <button
            type="button"
            className="cancel-btns mt-3"
            onClick={closeWizard}
          >
            Close Wizard
          </button>
        </div>
      </div>
    </div>
  );
};

export default SuccessfulOnboarded;
